import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReceiptCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.759 2h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 6.29 21 6.954 21 7.758V21a1 1 0 0 1-1.588.809l-2.133-1.552-1.904 1.524a1 1 0 0 1-1.213.028L12 20.236 9.838 21.81a1 1 0 0 1-1.213-.028l-1.904-1.523-2.133 1.55A1 1 0 0 1 3 21V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 2 7.954 2 8.758 2Zm7.448 6.707a1 1 0 0 0-1.414-1.414L11 11.086 9.707 9.793a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgReceiptCheck.displayName = 'ReceiptCheck';
export default SvgReceiptCheck;
